(() => {
  const bindings = new WeakMap();

  function enhanceNavigation(navigation) {
    if (bindings.has(navigation)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const menus = [...navigation.querySelectorAll('header-menu > details')];
    const triggers = [...navigation.querySelectorAll(':scope > ul > li > a, :scope > ul > li > header-menu > details > summary')];

    function close(menu, restoreFocus = false) {
      const disclosure = menu.closest('header-menu');
      if (typeof disclosure.close === 'function') disclosure.close();
      else menu.open = false;
      const trigger = menu.querySelector('summary');
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus();
    }

    function open(menu) {
      menus.forEach((other) => { if (other !== menu) close(other); });
      menu.open = true;
      menu.querySelector('summary').setAttribute('aria-expanded', 'true');
    }

    function move(items, index) {
      if (items.length) items[(index + items.length) % items.length].focus();
    }

    navigation.addEventListener('toggle', (event) => {
      if (!menus.includes(event.target)) return;
      const menu = event.target;
      menu.querySelector('summary').setAttribute('aria-expanded', String(menu.open));
      if (menu.open) menus.forEach((other) => { if (other !== menu) close(other); });
      const header = navigation.closest('.header-wrapper');
      // Dawn's HeaderMenu also handles this toggle at the target. Reconcile
      // after it runs so closing a sibling cannot hide an open menu's header.
      if (header) setTimeout(() => {
        if (!controller.signal.aborted) header.preventHide = menus.some((item) => item.open);
      });
    }, { ...options, capture: true });

    navigation.addEventListener('keydown', (event) => {
      const target = event.target.closest('a, summary');
      if (!target || event.altKey || event.ctrlKey || event.metaKey) return;
      const menu = target.closest('details');
      const topIndex = triggers.indexOf(target);
      let handled = true;

      if (event.key === 'Escape' && menu?.open) {
        close(menu, true);
      } else if (topIndex !== -1) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          menus.forEach((item) => close(item));
          move(triggers, topIndex + (event.key === 'ArrowRight' ? 1 : -1));
        } else if (event.key === 'Home' || event.key === 'End') {
          menus.forEach((item) => close(item));
          move(triggers, event.key === 'Home' ? 0 : triggers.length - 1);
        } else if (menu && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
          open(menu);
          const links = [...menu.querySelectorAll('.mega-menu__content a[href]')];
          move(links, event.key === 'ArrowDown' ? 0 : links.length - 1);
        } else handled = false;
      } else if (menu?.open) {
        const links = [...menu.querySelectorAll('.mega-menu__content a[href]')];
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          move(links, links.indexOf(target) + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key === 'Home' || event.key === 'End') {
          move(links, event.key === 'Home' ? 0 : links.length - 1);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          const branches = [...menu.querySelectorAll('.mega-menu__shopping-list > .mega-menu__branch')];
          const branch = target.closest('.mega-menu__branch');
          if (branch && branches.length > 1) {
            const index = branches.indexOf(branch) + (event.key === 'ArrowRight' ? 1 : -1);
            branches[(index + branches.length) % branches.length].querySelector('a[href]')?.focus();
          } else {
            const triggerIndex = triggers.indexOf(menu.querySelector('summary'));
            close(menu);
            move(triggers, triggerIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        } else handled = false;
      } else handled = false;

      if (handled) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, options);

    document.addEventListener('pointerdown', (event) => {
      if (!navigation.contains(event.target)) menus.forEach((menu) => close(menu));
    }, options);
    navigation.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!navigation.contains(document.activeElement)) menus.forEach((menu) => close(menu));
      });
    }, options);
    bindings.set(navigation, controller);
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-mdm-navigation]').forEach(enhanceNavigation);
  }

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mdm-navigation]').forEach((navigation) => {
      bindings.get(navigation)?.abort();
      bindings.delete(navigation);
    });
  });
})();
